import { isDev } from '@application/env';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { getTranslationUrl } from './api/getTranslationUrl';
import { logMissingKey } from './api/logMissingKey';

if (typeof window !== 'undefined') {
  i18n.use(Backend).use(initReactI18next);
}

const initI18n = (initialLanguage: string) => {
  if (i18n.isInitialized) {
    return;
  }

  i18n.init({
    debug: isDev(),
    lng: initialLanguage,
    fallbackLng: ['fr', 'nl', 'de', 'en'],
    supportedLngs: ['fr', 'nl', 'de', 'en'],
    ns: ['translations'],
    defaultNS: 'translations',
    returnNull: false,
    backend: {
      loadPath: async (lng: string) => {
        const url = await getTranslationUrl(lng);
        if (!url) {
          throw new Error(
            'Could not download translation file.\nCheck that translation file exists\nTG webhook "/webhook/locales/{lng}" must return a valid path to translation file\n',
          );
        }
        return url;
      },
    },
    saveMissing: true,
    missingKeyHandler: (lngs, namespace, key, fallbackValue) => {
      logMissingKey(key);
    },
  });
};

export { i18n, initI18n };
